import { render, staticRenderFns } from "./lookLogisticsInfo.vue?vue&type=template&id=2ad34a41&scoped=true&"
import script from "./lookLogisticsInfo.vue?vue&type=script&lang=js&"
export * from "./lookLogisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./lookLogisticsInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lookLogisticsInfo.vue?vue&type=style&index=1&id=2ad34a41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad34a41",
  null
  
)

export default component.exports